import { render, staticRenderFns } from "./DotLoading.vue?vue&type=template&id=5949348c&"
import script from "./DotLoading.vue?vue&type=script&lang=js&"
export * from "./DotLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports